import { render, staticRenderFns } from "./PlansModal.vue?vue&type=template&id=a2f7c0e6&scoped=true&"
import script from "./PlansModal.vue?vue&type=script&lang=ts&"
export * from "./PlansModal.vue?vue&type=script&lang=ts&"
import style0 from "./PlansModal.vue?vue&type=style&index=0&id=a2f7c0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f7c0e6",
  null
  
)

export default component.exports